<div class="nutzerschlagwort text-truncate" :id="badgeId" :class="badgeCls" :title="badgeLabel">{{ badgeLabel }}</div>